{ "id": "bottes-aventurier", "name": "Bottes de l'Aventurier", "slot": "bottes", "set": "aventurier", "tier": 1, "price": 50, "icon": "icons/items/bottes-aventurier", "stats": { "force": 5, "intelligence": 5, "chance": 5, "agilite": 5 } }
